/* hand-written — not generated; do not run `pnpm generate:api` over this. */
/* Mirrors POST /api/v1/chat/feedback. Auth (Bearer JWT + x-api-key) is    */
/* injected by `OpenAPI.TOKEN` / `OpenAPI.HEADERS` from open_api_injection. */

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
import type { ChatFeedbackRequest } from "../models/ChatFeedbackRequest";
import type { MessageOnlyResponse } from "../models/MessageOnlyResponse";

export class ChatFeedbackService {
  /**
   * Submit thumb up/down feedback on a specific assistant message.
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static submitChatFeedbackApiV1ChatFeedbackPost(
    requestBody: ChatFeedbackRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/chat/feedback",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
